import { Link as ReactLink } from 'react-router-dom';
import { get } from 'lodash';
import { array, bool, object } from 'prop-types';

import * as paths from '../../config/paths';
import { createRoute } from '../../lib/router';

import styled from 'styled-components';
import { colors } from '@podiumhq/podium-ui';
import { Button, Icon } from '@podiumhq/design-system';

import SystemStatus from './TabSystemStatus';

const TabPersonal = props => {
  const { isLocationHome, rolePermissions } = props;

  const userRole = get(rolePermissions, '[0].role', '');

  const canCreateTestOrg = userRole !== 'supportReps';

  return (
    <LinkContainer>
      <StatusContainer>{isLocationHome && <SystemStatus />}</StatusContainer>
      {canCreateTestOrg && (
        <Link to={paths.ORGANIZATION_NEW} id="create-test-org-btn">
          <CreateOrgButton
            bg={colors.mineShaft}
            fontSize="14px"
            height="2rem"
            leftIcon="Wand"
            variant="primary"
          >
            Create Test Org
          </CreateOrgButton>
        </Link>
      )}
      <Link
        to={createRoute(paths.FAVORITES)}
        id="favorites-btn"
        aria-label="favorites"
      >
        <Icon type="Bookmark" boxSize={5} color="grey.lightest" />
      </Link>

      <Link to={paths.LOGOUT} id="logout-btn" aria-label="logout">
        <Icon type="SignOut" boxSize={5} color="grey.lightest" />
      </Link>
    </LinkContainer>
  );
};

TabPersonal.propTypes = {
  currentUser: object.isRequired,
  isLocationHome: bool.isRequired,
  rolePermissions: array.isRequired,
};

const LinkContainer = styled.div`
  height: 60px;
  display: flex;
  align-items: center;
`;

const StatusContainer = styled.span`
  align-self: flex-start;
  margin-top: 10px;
  margin-right: 10px;
  @media (max-width: 1250px) {
    display: none;
  }
`;

const Link = styled(ReactLink)`
  cursor: pointer;
  margin: 0 10px;
  &:last-child {
    margin-right: 0px;
  }
`;

const CreateOrgButton = styled(Button)`
  border-radius: 5px !important;
  &:not([disabled]):hover {
  &:hover {
    background-color: ${colors.jumbo} !important;
  }
`;

export default TabPersonal;
